import {
    GETCHARGEMASTERLIST_SUCCESS,
    GETCHARGEMASTERLIST_FAILED,
    RESET_GETCHARGEMASTERLIST,
    LOADING_GETCHARGEMASTERLIST,
    NETWORK_ERROR_GETCHARGEMASTERLIST
} from "../types/index";
import { partnerServices } from "../../config/axios";

const resetGetChargeMasterList = () => {
    return { type: RESET_GETCHARGEMASTERLIST };
};

const getChargeMasterList = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_GETCHARGEMASTERLIST });
    await partnerServices
        .post("listChargeMaster", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch(getChargeMasterListsuccess(res.data));
                    break;
                default:
                    dispatch(getChargeMasterListFailed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({
                type: NETWORK_ERROR_GETCHARGEMASTERLIST,
                payload: err
            });
        });
};
function getChargeMasterListsuccess(data) {
    return {
        type: GETCHARGEMASTERLIST_SUCCESS,
        payload: data
    };
}
function getChargeMasterListFailed(data) {
    return {
        type: GETCHARGEMASTERLIST_FAILED,
        payload: data
    };
}

export { resetGetChargeMasterList, getChargeMasterList };
